import { render, staticRenderFns } from "./questionSelector.vue?vue&type=template&id=b82ad09c&scoped=true&"
import script from "./questionSelector.vue?vue&type=script&lang=js&"
export * from "./questionSelector.vue?vue&type=script&lang=js&"
import style0 from "./questionSelector.vue?vue&type=style&index=0&id=b82ad09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82ad09c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b82ad09c')) {
      api.createRecord('b82ad09c', component.options)
    } else {
      api.reload('b82ad09c', component.options)
    }
    module.hot.accept("./questionSelector.vue?vue&type=template&id=b82ad09c&scoped=true&", function () {
      api.rerender('b82ad09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/questionSelector.vue"
export default component.exports